import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const SimulationStartDate = () => {
  const sim_start_date = useInputStore(state => state.sim_start_date)
  const setValue = useInputStore((state) => state.set_value)

  const handleChange = (event) => {
    setValue({ 'sim_start_date': event.target.value})
  }

  // validation
  const isValidDate = useCallback(() => {
    const date = new Date(sim_start_date)
    // is it a valid date
    return !isNaN(date)
  }, [sim_start_date])

  useStepValidator(INPUT_STEP_NAMES.simulation, 'sim_start_date', () => isValidDate(sim_start_date))  
  
  return (
    <Tooltip title='What date do you want to start the simulation?'>
      <TextField
        size='small'
        label='Start Simulation'
        type='date'
        InputLabelProps={{
          shrink: true,
        }}
        value={sim_start_date}
        onChange={handleChange}
        error={!isValidDate()}
        helperText={!isValidDate() ? 'Please select a valid date' : ''}
      />
    </Tooltip>
  )
}
